import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import _ from 'lodash';

import { Paginator } from './Tabular';
import { BasicText } from '../Styles';

const ListBlock = styled.View`
    background: ${props=>isEven(props.index) ? '#f9f9f9' : '#f1f1f1' };
    border-bottom-width: 1px;
    border-bottom-color: #f1f1f1;
    padding: 10px;
`;

const isEven = (n) =>{
    return n % 2 == 0;
}

const List = ({children = (data)=> { return <BasicText>No Children</BasicText> }, data, resultsPerPage = 8, initialPage = 0, pageSetter = undefined, style = undefined}) => {
    const [page, setPage] = useState(initialPage);
    const chunks = _.chunk(data, resultsPerPage);

    useEffect(()=>{
        setPage(initialPage);
    },[initialPage]);

    const blocks = _.map(chunks[page], (chunk, index) => {
        return <ListBlock index={index} key={index}>
            {children(chunk)}
        </ListBlock>
    });
    
    const setCurrentPage = (pageNum) => {
        if(pageSetter != undefined){
            pageSetter(pageNum);
        } else {
            setPage(pageNum);
        }
    }

    return <View style={style}>
        {blocks}
        {chunks.length > 0 ? <Paginator currentPageIdx={page} setPage={(page)=>setCurrentPage(page)}>{chunks}</Paginator> : null}
    </View>
}

export { List };